<h1>Ajuda/Suporte</h1>
<div *ngIf="!isDiscente">
  <iframe
    referrerpolicy="same-origin"
    [src]="trustedUrl"
    width="100%"
    height="{{ iframeHeight }}"
    frameborder="0"
    cellspacing="0">
    <p>Your browser does not support iframes.</p>
  </iframe>
</div>
<div *ngIf="isDiscente">
  <mat-card class="card-warning">
    <p>
      Prezado discente, consulte a página de
      <b><a routerLink="/discente/status-inscricao">Status das inscrições</a></b> e, se houver dúvidas sobre alguma das
      etapas, por favor, procure o responsável indicado.<br />Em caso de dúvidas sobre regras e procedimentos do PAADES,
      consulte a Seção Técnica de Pós-graduação da sua unidade.
    </p>
    <br />
    <p>
      Mais informações em:
      <a href="https://www2.unesp.br/propg/paades" target="_blank">https://www2.unesp.br/propg/paades</a>
    </p>
  </mat-card>
</div>
